<template>
    <div>
        <b-row class="mt-3">
            <b-col>
                <h3>
                    Visitas a clientes en
                    <span class="text-warining">{{ month }}/{{ year }}</span>
                    (Reuniones registradas)
                </h3>
            </b-col>
        </b-row>
        <b-row class="my-3">
            <b-col>
                <label for="period">Periodo</label>
                <input
                    type="month"
                    id="period"
                    name="monthYear"
                    v-model="period"
                />
            </b-col>
        </b-row>
        <div>
            <b-row v-if="!!callsIndicators.length">
                <b-col>
                    <app-client-calls-indicators
                        :users="callsIndicators"
                    ></app-client-calls-indicators>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col> No hay datos para mostrar </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import appClientCallsIndicators from '@/components/Reporting/Charts/ClientCallsIndicators.vue'
export default {
    components: {
        appClientCallsIndicators,
    },
    props: {
        //
    },
    data: () => ({
        callsIndicators: [],
        month: new Date().getMonth() + 1,
        period: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
        year: new Date().getFullYear(),
    }),
    watch: {
        period: function (val) {
            const [year, month] = val.split('-')
            this.year = year
            this.month = month
            this.loadCallsIndicators()
        },
    },
    methods: {
        getCurrentYearMonth() {
            const now = new Date()
            const year = now.getFullYear()
            const month = (now.getMonth() + 1).toString().padStart(2, '0')
            return `${year}-${month}`
        },
        async loadCallsIndicators() {
            try {
                console.log('Loading calls indicators')
                const { data } = await this.$repo.get(
                    'dashboards/leaders/client-calls-indicators',
                    {
                        year: this.year,
                        month: this.month,
                    }
                )
                this.callsIndicators = data.sort((a, b) =>
                    a.percentage <= b.percentage ? 1 : -1
                )
            } catch (error) {
                toastr.error('Error al cargar los indicadores de llamadas')
            }
        },
    },
    mounted() {
        this.period = this.getCurrentYearMonth()
        this.loadCallsIndicators()
    },
}
</script>
